import { render, staticRenderFns } from "./ProgressSpinnerWrapper.vue?vue&type=template&id=31ae8251&scoped=true&"
import script from "./ProgressSpinnerWrapper.vue?vue&type=script&lang=ts&"
export * from "./ProgressSpinnerWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae8251",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
